/**
 * Joins a path with Create React App's `PUBLIC_URL` so links and the service worker
 * resolve correctly for both the open web and an installed PWA (including subpath deploys).
 */
export function publicPath(path: string): string {
  const base = process.env.PUBLIC_URL ?? '';
  const suffix = path.startsWith('/') ? path : `/${path}`;
  if (!base) {
    return suffix;
  }
  return `${base.replace(/\/$/, '')}${suffix}`;
}
